/**
 * Sectors Slider Module
 */

export default function initSectorsSlider() {
  const sectorsSliders = document.querySelectorAll('.sectors-slider');
  if (!sectorsSliders.length) return;

  sectorsSliders.forEach(slider => {
    const navSwiper = slider.querySelector('.sectors-nav-swiper');
    const contentSwiper = slider.querySelector('.sectors-content-swiper');
    
    if (!navSwiper || !contentSwiper) return;

    // Initialize navigation swiper
    const sectorsNavSwiper = new window.Swiper(navSwiper, {
      modules: [window.SwiperModules.Navigation],
      freeMode: true,
      direction: 'horizontal',
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 'auto',
          spaceBetween: 30
        }
      },
    });

    // Initialize content swiper
    const sectorsContentSwiper = new window.Swiper(contentSwiper, {
      modules: [window.SwiperModules.EffectFade, window.SwiperModules.Thumbs],
      spaceBetween: 30,
      slidesPerView: 1,
      centeredSlides: true,
      centerInsufficientSlides: true,
      thumbs: {
        swiper: sectorsNavSwiper,
      }
    });

    // Create custom dot indicators
    const createDotIndicators = () => {
      const navSlides = slider.querySelectorAll('.sector-nav-item');
      const dotsContainer = slider.querySelector('.sectors-nav-pagination');
      
      // Clear existing dots
      dotsContainer.innerHTML = '';
      
      // Create a dot for each slide
      navSlides.forEach((slide, index) => {
        const dot = document.createElement('div');
        dot.className = 'sector-dot';
        dot.setAttribute('data-slide-index', index);
        dotsContainer.appendChild(dot);
        
        // Add click handler to dot
        dot.addEventListener('click', () => {
          sectorsContentSwiper.slideTo(index);
        });
      });
    };

    // Update dot indicators based on active slide
    const updateDotIndicators = () => {
      const dots = slider.querySelectorAll('.sector-dot');
      const activeIndex = sectorsContentSwiper.activeIndex;
      
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    };

    // Initialize dots
    createDotIndicators();
    updateDotIndicators();

    // Update dots on slide change
    sectorsContentSwiper.on('slideChange', updateDotIndicators);

    // Add click handlers to navigation items
    const navItems = slider.querySelectorAll('.sector-nav-item');
    navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        sectorsContentSwiper.slideTo(index);
        
        // On mobile screens, scroll the clicked item into view
        if (window.innerWidth < 1024) {
          const navWrapper = navSwiper.querySelector('.swiper-wrapper');
          if (navWrapper) {
            const itemLeft = item.offsetLeft;
            const itemWidth = item.offsetWidth;
            const wrapperWidth = navWrapper.offsetWidth;
            const scrollLeft = itemLeft - (wrapperWidth / 2) + (itemWidth / 2);
            
            navWrapper.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }
      });
    });
  });
}

// Auto-initialize
document.addEventListener('DOMContentLoaded', initSectorsSlider);
